(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biotec-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const bars = document.querySelectorAll('.bab[data-section-id]');
    bars.forEach(bar => {
      const closeBtn = bar.querySelector('[data-close]');
      const dismissKey = bar.dataset.dismissKey;
      if (!closeBtn || !dismissKey) return;

      try {
        if (sessionStorage.getItem(dismissKey) === '1') {
          bar.classList.add('is-dismissed');
        }
      } catch (e) {}

      closeBtn.addEventListener('click', () => {
        bar.classList.add('is-dismissed');
        try { sessionStorage.setItem(dismissKey, '1'); } catch (e) {}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biotec-main-collection"]) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.bcl[data-section-id]');
    sections.forEach(section => {

      /* Auto-submit sort dropdown */
      const sortEl = section.querySelector('[data-sort]');
      if (sortEl) {
        sortEl.addEventListener('change', () => sortEl.closest('form').submit());
      }

      /* Filters drawer (mobile) */
      const toggle = section.querySelector('[data-toggle-filters]');
      const closeBtn = section.querySelector('[data-close-filters]');
      const backdrop = section.querySelector('[data-backdrop]');

      const open = () => {
        section.classList.add('is-filters-open');
        document.body.style.overflow = 'hidden';
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        section.classList.remove('is-filters-open');
        document.body.style.overflow = '';
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      };

      if (toggle) toggle.addEventListener('click', () => {
        section.classList.contains('is-filters-open') ? close() : open();
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (backdrop) backdrop.addEventListener('click', close);

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && section.classList.contains('is-filters-open')) close();
      });

      /* AJAX Add to cart from grid */
      section.querySelectorAll('[data-bcl-atc]').forEach(form => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('[data-atc-btn]');
          const label = form.querySelector('[data-atc-label]');
          if (!btn || !label) return;

          const originalText = label.textContent;
          const idInput = form.querySelector('[name=id]');
          if (!idInput) return;

          btn.disabled = true;
          btn.classList.add('is-adding');
          label.textContent = 'Añadiendo…';

          try {
            const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/javascript'
              },
              body: JSON.stringify({
                items: [{ id: idInput.value, quantity: 1 }],
                sections: 'cart-drawer,cart-icon-bubble'
              })
            });

            const data = await res.json();

            if (!res.ok) {
              throw new Error(data.description || 'Error');
            }

            btn.classList.remove('is-adding');
            btn.classList.add('is-added');
            label.textContent = '✓ Añadido';

            /* Refresh cart drawer if present */
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents({ sections: data.sections, items: [data] });
              if (typeof drawer.open === 'function') drawer.open();
            } else if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              /* Fallback: update cart bubble count */
              document.querySelectorAll('cart-icon-bubble, .cart-count-bubble').forEach(el => {
                const countEl = el.querySelector('span');
                if (countEl && data.item_count != null) countEl.textContent = data.item_count;
              });
            }

            /* Publish generic cart:updated event */
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

            setTimeout(() => {
              btn.classList.remove('is-added');
              btn.disabled = false;
              label.textContent = originalText;
            }, 1800);
          } catch (err) {
            console.error(err);
            btn.classList.remove('is-adding');
            label.textContent = 'Error, reintentar';
            setTimeout(() => {
              btn.disabled = false;
              label.textContent = originalText;
            }, 2000);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biotec-main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('.bpr[data-section-id="{{ section.id }}"]');
    if (!root) return;

    /* ───── GALLERY: thumbnails ───── */
    const mainImg = root.querySelector('[data-main-img-el]');
    const thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (!mainImg) return;
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
          mainImg.style.opacity = '1';
        }, 120);
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    /* ───── QTY stepper ───── */
    const qtyInput = root.querySelector('[data-qty-input]');
    const qtyMinus = root.querySelector('[data-qty-minus]');
    const qtyPlus  = root.querySelector('[data-qty-plus]');
    const maxQty = qtyInput ? parseInt(qtyInput.dataset.maxQty || '999', 10) : 999;
    if (qtyMinus) qtyMinus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      qtyInput.value = v;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', () => {
      const v = Math.min(maxQty, Math.max(1, parseInt(qtyInput.value || '1', 10) + 1));
      qtyInput.value = v;
    });

    /* ───── BUY NOW (direct checkout) ───── */
    const buyNowBtn = root.querySelector('[data-buy-now]');
    const returnToInput = root.querySelector('[data-return-to]');
    if (buyNowBtn && returnToInput) {
      buyNowBtn.addEventListener('click', () => {
        returnToInput.value = '/checkout';
      });
    }

    /* ───── VARIANT picker ───── */
    const variantsScript = root.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const variantInput = root.querySelector('[data-variant-id]');
    const priceEl      = root.querySelector('[data-price]');
    const compareEl    = root.querySelector('[data-compare-price]');
    const discountEl   = root.querySelector('[data-discount]');
    const atcBtn       = root.querySelector('[data-atc]');
    const atcText      = root.querySelector('[data-atc-text]');
    const optInputs    = root.querySelectorAll('[data-option-value]');

    function formatMoney(cents) {
      const currency = '{{ shop.currency }}';
      const symbol = ({ EUR: '€', USD: '$', GBP: '£' })[currency] || currency;
      const value = (cents / 100).toFixed(2).replace('.', ',');
      return currency === 'EUR' ? `${value} ${symbol}` : `${symbol}${value}`;
    }

    function getSelectedOptions() {
      const opts = [];
      root.querySelectorAll('.bpr__option').forEach(optGroup => {
        const selected = optGroup.querySelector('[data-option-value]:checked');
        if (selected) opts.push(selected.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(v => {
        return v.options.every((val, i) => val === opts[i]);
      });
    }

    function updateUI() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);
      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcText.textContent = 'No disponible'; }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (discountEl) {
            const rawPct = (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price;
            const pct = Math.ceil(rawPct / 5) * 5;
            discountEl.textContent = '-' + pct + '%';
            discountEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (discountEl) discountEl.style.display = 'none';
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        if (atcText) atcText.textContent = variant.available
          ? '{{ section.settings.atc_label | default: "Añadir al carrito" | escape }}'
          : 'Agotado';
      }
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src;
      }
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    optInputs.forEach(inp => inp.addEventListener('change', updateUI));
  })();

  document.addEventListener("click", function(e) {
    var btn = e.target.closest("button.bpr__thumb");
    if (!btn) return;
    var root = btn.closest(".bpr__gallery");
    if (!root) return;
    var mainImg = root.querySelector(".bpr__main-img img");
    if (!mainImg) return;
    e.preventDefault();
    var src = btn.dataset.src;
    var alt = btn.dataset.alt || mainImg.alt;
    if (src) { mainImg.src = src; mainImg.srcset = src; mainImg.alt = alt; }
    root.querySelectorAll("button.bpr__thumb").forEach(function(b) { b.classList.remove("is-active"); });
    btn.classList.add("is-active");
    });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biotec-related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.brp[data-section-id]');
    sections.forEach(section => {
      const url = section.dataset.url;
      if (!url) return; /* only automatic mode has data-url */

      fetch(url)
        .then(r => r.text())
        .then(html => {
          const fresh = new DOMParser().parseFromString(html, 'text/html')
            .querySelector('.brp[data-section-id="' + section.dataset.sectionId + '"]');
          if (fresh) section.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
